<template style="z-index=1000">
  <el-dialog title="Fechar Caixa" @open="open" :visible.sync="visibility" :before-close="fechar" :close-on-click-modal="false" append-to-body width="700px" v-loading="loading">
    <el-form :model="caixa" ref="form" size="small" label-position="top" hide-required-asterisk	:show-message="false">
      <el-row :gutter="10">
        <el-col :span="12">
          <el-tag>Saldo Atual em Dinheiro: {{ saldoDinheiroCalculado }}</el-tag>
        </el-col>
        <el-col :span="12">
          <el-tag>Saldo Atual em Cheques: {{ saldoChequeCalculado }} </el-tag>
        </el-col>
      </el-row>
      <el-row :gutter="10" style="margin-top: 20px">
        <el-col :span="12">
          <el-form-item label="Saldo em Dinheiro">
            <div class="el-input el-input--small">
              <money auto-complete="off" v-model="saldoDinheiro" v-bind="money" class="el-input__inner"/>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Saldo em Cheques">
            <div class="el-input el-input--small">
              <money auto-complete="off" v-model="saldoCheque" v-bind="money" class="el-input__inner"/>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10" style="margin-top: 10px">
        <el-col :span="24" style="text-align: center">
          <el-button @click="fecharCaixaHandler" type="primary" size="small" style="width: 50%" round class="btn-box-shadow">Fechar Caixa</el-button>
        </el-col>
      </el-row>
    </el-form>
  </el-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Util from '../../util/funcoes.js';
import { Money } from "v-money";

const BigDecimal = require('js-big-decimal');

export default {
  props: {
    caixa: Object,
    saldo: Number,
    visibility: Boolean
  },
  components: {
    Money
  },
  data() {
    return {
      caixaFechamento: {},
      saldoFechamento: 0,
      saldoDinheiro: 0,
      saldoCheque: 0,
      saldoDinheiroCalculadoNumber: 0,
      saldoChequeCalculadoNumber: 0,

      validacao: {
        valor: [
          { required: true},
          { type: 'number', min: 0.1}
        ]
      },

      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2,
        masked: false
      }
    }
  },
  computed: {
    ...mapState("loginStore", {
      usuarioLogado(state) { return state.usuarioLogado }
    }),
    util() {
      return Util;
    },
    loading() {
      return this.$store.state.loading;
    },

    saldoDinheiroCalculado() {
      return Util.formatarValor(this.saldoDinheiroCalculadoNumber);
    },
    saldoChequeCalculado() {
      return Util.formatarValor(this.saldoChequeCalculadoNumber);
    },
  },
  methods: {
    ...mapActions([
        'showLoading',
        'hideLoading'
    ]),
    ...mapActions('caixaStore', [
        'fecharCaixa',
        'recuperarSaldo',
    ]),

    open() {
      this.reset();

      this.handleRecuperarSaldo();
    },

    handleRecuperarSaldo() {
      const payload = {
        id: this.caixa.id,
      };

      this.showLoading();

      this.recuperarSaldo(payload)
        .then(resultado => {
          this.saldoDinheiroCalculadoNumber = resultado.item.saldoDinheiro;
          this.saldoChequeCalculadoNumber = resultado.item.saldoCheque;
        })
        .finally(() => {
          this.hideLoading();
        });
    },

    obterSaldoFechamento(saldoDinheiro, saldoCheque) {
      const saldoDinheiroBigDecimal = new BigDecimal(saldoDinheiro);
      const saldoChequeBigDecimal = new BigDecimal(saldoCheque);

      const saldoFechamento = saldoDinheiroBigDecimal.add(saldoChequeBigDecimal);

      return saldoFechamento.getValue();
    },

    fecharCaixaHandler() {
      this.saldoFechamento = this.obterSaldoFechamento(this.saldoDinheiro, this.saldoCheque);
      
      this.caixaFechamento = {
        id: this.caixa.id,
        saldoFechamento: this.saldoFechamento,
        saldoDinheiro: this.saldoDinheiro,
        saldoCheque: this.saldoCheque,
      }

      this.$confirm("Fechar caixa com saldo de " + this.util.formatarValor(this.saldoFechamento) + "?", "Atenção", {
          confirmButtonText: "Sim",
          cancelButtonText: "Não",
          type: "warning"
      }).then(() => {
        this.showLoading()

        this.fecharCaixa(this.caixaFechamento).then(resultado => {
            this.hideLoading()
            switch(resultado.status) {
              case "SUCESSO":
                  this.$message.success(resultado.mensagem);
                  this.fechar('SUCESSO')
                  break;
              case "FALHA":
                  this.$message.warning(resultado.mensagem);
                  break;
              case "ERRO":
                  this.$message.error(resultado.mensagem);
                  break;
            }
            this.fechar(undefined)
        })
        .catch(() => {
          this.hideLoading()
          this.$message.error("Não foi possível conectar-se ao servidor");
          this.fechar(undefined)
        });        
      });
    },

    // UTIL
    reset(){
      this.caixaFechamento = {};
      this.saldoFechamento = 0;
      this.saldoDinheiro = 0;
      this.saldoCheque = 0;
      this.saldoDinheiroCalculadoNumber = 0;
      this.saldoChequeCalculadoNumber = 0;
    },
    exibirAlert(titulo, mensagem) {
        this.$alert(mensagem, titulo, { confirmButtonText: 'OK' });
    },
    fechar(result) {
      this.$emit('close',result);
    } 
  }
}
</script>
